import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "max-width": _ctx.width,
    persistent: _ctx.persistent,
    "onClick:outside": _ctx.closeDialog,
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDialog) = $event)),
    onKeydown: _withKeys(_ctx.closeDialog, ["esc"]),
    fullscreen: _ctx.fullscreen,
    transition: _ctx.transition,
    class: _normalizeClass(_ctx.fullscreen ? 'fullscreen' : '')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: _normalizeClass(["d-flex justify-space-between white--text align-center", _ctx.color])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.$t("titles.infoMessage")), 1)
              ], true),
              _createVNode(_component_v_btn, {
                icon: "",
                title: _ctx.$t('buttons.close'),
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "white",
                    icon: "mdi-close"
                  })
                ]),
                _: 1
              }, 8, ["title", "onClick"])
            ]),
            _: 3
          }, 8, ["class"]),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "py-4 dialog-body" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "body", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.$t("titles.infoMessage")), 1)
              ], true)
            ]),
            _: 3
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, { class: "d-flex justify-end" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "actions", {}, () => [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  onClick: _ctx.closeDialog
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("buttons.ok")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ], true)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["max-width", "persistent", "onClick:outside", "modelValue", "onKeydown", "fullscreen", "transition", "class"]))
}